module.exports = __webpack_public_path__ + "static/media/26UNRWA6.f271a331.jpg";